import SafeImage from './presenter';
export default SafeImage;
